// Complete Text config to use to render text assets in a specific page

const pageTextConfig = {
  Banner: {
    heading1: 'Your Business Needs are one click away',
    heading2: 'from getting completed',
    para: 'Find all the categories which suits your requirements'
  },
  RequestNew: {
    heading: 'Didn’t see your desired category?',
    para: 'Let us know which category we should add on GenieGig',
    input0: 'Your Email',
    input1: 'Category',
    input2: 'Subcategory',
    textArea: 'Any Comments?'
  }
}

export default pageTextConfig